import { AvailabilityMessageType } from "@insite/client-framework/Types/ApiModels";

export const loadBucketsItems = <T = any>(cartLines: T[]) => {
    const shippingNowList =
        cartLines.filter(
            (item: any) =>
                item.availability?.messageType === AvailabilityMessageType.Available &&
                (!item.properties["isBackordered"] || item.properties["isBackordered"]?.toLowerCase() !== "true") &&
                (!item.properties["isPartialShipment"] ||
                    item.properties["isPartialShipment"]?.toLowerCase() !== "true") &&
                (item.properties["scheduledShipments"] == null || item.properties["scheduledShipments"].length === 0),
        ) ?? [];

    const partialShipmentList =
        cartLines.filter(
            (item: any) =>
                item.properties["isPartialShipment"] && item.properties["isPartialShipment"].toLowerCase() === "true",
        ) ?? [];

    const backorderedList =
        cartLines.filter(
            (item: any) =>
                (!item.properties["isPartialShipment"] ||
                    item.properties["isPartialShipment"]?.toLowerCase() !== "true") &&
                (item.availability?.messageType === AvailabilityMessageType.OutOfStock ||
                    (item.properties["isBackordered"] && item.properties["isBackordered"].toLowerCase() === "true")),
        ) ?? [];

    const scheduledShipmentsList =
        cartLines.filter(
            (item: any) =>
                item.properties["scheduledShipments"] != null &&
                item.properties["scheduledShipments"].length > 0 &&
                (item.properties["isPartialShipment"] == null ||
                    item.properties["isPartialShipment"].toLowerCase() !== "true") &&
                (item.properties["isBackordered"] == null || item.properties["isBackordered"].toLowerCase() !== "true"),
        ) ?? [];

    return {
        shippingNowList,
        partialShipmentList,
        backorderedList,
        scheduledShipmentsList,
    };
};
